import { afterRender, Component, Input } from '@angular/core';

declare global {
  interface Window {
    copper: any;
  }
}

@Component({
  selector: 'app-copper',
  imports: [],
  templateUrl: './copper.component.html',
  styleUrl: './copper.component.scss',
})
export class CopperComponent {
  @Input() copper!: string;
  @Input() _editable!: string;

  @Input() _uid!: string;
  @Input() component!: string;

  constructor() {
    afterRender(() => {});
  }
}
